import React, { createContext, useState, useEffect, useContext } from "react";
import publicApi from "../../publicApi";

const ServerStatusContext = createContext();

export const useServerStatus = () => useContext(ServerStatusContext);

export const ServerStatusProvider = ({ children }) => {
  const [isServerOnline, setIsServerOnline] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        await publicApi.get("/products");
        setIsServerOnline(true);
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          setIsServerOnline(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkServerStatus();

    let intervalId = null;
    const startPolling = () => {
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(checkServerStatus, 60000);
    };
    const stopPolling = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        stopPolling();
      } else {
        checkServerStatus();
        startPolling();
      }
    };

    startPolling();
    document.addEventListener("visibilitychange", onVisibility);

    if (document.visibilityState === "hidden") {
      stopPolling();
    }

    return () => {
      stopPolling();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  const value = { isServerOnline, isLoading };

  return (
    <ServerStatusContext.Provider value={value}>
      {children}
    </ServerStatusContext.Provider>
  );
};
